import React from "react";

export default function TicketQuantityPicker({ title, value, onChange, max = 10 }) {
    const dec = () => onChange(Math.max(0, (value || 0) - 1));
    const inc = () => onChange(Math.min(max, (value || 0) + 1));

    return (
        <div className="w-full h-[55vh] md:h-[60vh] rounded-xl border border-white/10 bg-black/20 flex items-center justify-center p-6">
            <div className="w-full max-w-sm text-center">
                <div className="text-white/90 text-lg font-semibold mb-2">{title}</div>
                <div className="text-white/60 text-sm mb-6">Selecciona cantidad</div>

                <div className="flex items-center justify-center gap-4">
                    <button
                        type="button"
                        onClick={dec}
                        className="h-12 w-12 rounded-full bg-white/10 hover:bg-white/15 text-white text-xl"
                    >
                        −
                    </button>

                    <div className="min-w-[80px] text-4xl font-bold text-white">{value || 0}</div>

                    <button
                        type="button"
                        onClick={inc}
                        className="h-12 w-12 rounded-full bg-white/10 hover:bg-white/15 text-white text-xl"
                    >
                        +
                    </button>
                </div>

                <div className="mt-4 text-white/50 text-xs">
                    Máximo {max} por persona
                </div>
            </div>
        </div>
    );
}
